import { periodColumn } from 'components/columns';
import { BlockWidget, BoundStates, ClientTitle } from 'components';
import { sepFormat } from 'utilities';
import type { ListBlock } from 'modules/campaign/block/types';
import { TableColumns } from '@ff-it/ui';
import { BlockStatusTag } from 'modules/campaign/status/BlockStatusTag';

const sumProps = {
  width: 100,
  cellProps: {
    textAlign: 'end' as const,
    className: 'px-1',
  },
};

export const columns: TableColumns<ListBlock> = [
  {
    content: 'Block',
    key: 'code',
    minWidth: 150,
    cellProps: { className: 'py-1' },
    render: (block: ListBlock) => <BlockWidget {...block} campaign_id={block.campaign.id} link target="_self" />,
    sortable: true,
  },
  {
    content: 'Status',
    width: 100,
    key: 'status',
    cellProps: {
      flush: true,
      textAlign: 'left',
    },
    // sortable: true,
    render: ({ status }) => <BlockStatusTag appearance="naked" status={status} />,
  },

  {
    content: 'Client',
    key: 'client',
    render: ({ campaign }) => <ClientTitle {...campaign} />,
    cellProps: {
      className: 'py-1',
    },
  },
  periodColumn,
  {
    ...sumProps,
    content: 'Income',
    key: 'sums.income_total',
    render: ({ sums }) => sepFormat(sums ? sums.income_total : null),
    sortable: true,
  },
  {
    ...sumProps,
    content: 'Expense',
    key: 'sums.expense_total',
    render: ({ sums }) => sepFormat(sums ? sums.expense_total : null),
    sortable: true,
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.revenue',
    sortable: true,
    render: ({ sums }) => sepFormat(sums ? sums.revenue : null),
  },
  {
    width: 40,
    cellProps: {
      flush: true,
      textAlign: 'center',
      className: 'pr-0',
    },
    key: 'sums',
    render: ({ sums }: ListBlock) => (sums ? <BoundStates {...sums} /> : null),
  },
];
